import * as api from "../client";

const BASE = "/v1/profiles/user-guide";

/**
 * Editable Profiles help document ("user guide").
 *
 * Singleton keyed by `slug` ("profiles") — the GET endpoint always resolves a
 * guide (empty `content` when none has been saved yet), so callers never have
 * to handle a 404. Writes require the staff-only `profiles.user_guide.write`
 * permission; the server sanitises the submitted HTML before persisting.
 */
export type UserGuide = {
  slug: string;
  content: string;
  updatedAt: string;
  updatedBy: string | null;
};

export const userGuideService = {
  async get(): Promise<UserGuide> {
    const raw = await api.get<{ userGuide: UserGuide }>(BASE);
    return raw.userGuide;
  },

  async update(content: string): Promise<UserGuide> {
    const raw = await api.put<{ userGuide: UserGuide }>(BASE, { content });
    return raw.userGuide;
  },
};
